import React from 'react';
import Header from './header';
import { Outlet } from 'react-router-dom';
import Sidebar from './sidebar';

const Layout = ({ children }) => {
    return (
        <div>
            <Header />
            <Sidebar/>
            <Outlet/>
            {children}
        </div>
    );
}

export default Layout;
